import { sbaAxios } from "../utils/sbaAxios";
import {
  FETCH_ADMINPERMISSIONS_BEGIN,
  FETCH_ADMINPERMISSIONSTENANT_SUCCESS,
  FETCH_ADMINPERMISSIONS_FAILURE,     
  FETCH_ADMINTHEMES_BEGIN,
  FETCH_ADMINTHEMELIST_SUCCESS,
  FETCH_ADMINTHEME_SUCCESS,
  FETCH_ADMINREPORT_SUCCESS,
  FETCH_ADMINREPORTPART_SUCCESS,
  FETCH_ADMINREPORTPARTLIST_SUCCESS,
  FETCH_ADMINTHEMEDETAILS_SUCCESS,
  FETCH_ADMINTHEMES_FAILURE,       
    } from '../constants/adminPermissions'
import { getTenants, getThemes, getReports, getThemeDetails, getThemeList, getReportPartList, getReportpartListById} from '../../config/apiConfig';

export const getTenantsDataAction=()=>{ 
  return async (dispatch) => {
    dispatch(getTenantsDataActionBegin());
      try {
          const response = await sbaAxios({
              url: `${getTenants}`,
              method: 'get',
          })
        const TenantData = response;
        dispatch(getTenantsDataActionSuccess(TenantData));
      } catch (error) {
        if (error.message === 'Network Error') {
          dispatch(getTenantsDataActionSuccess({}));
        } else {
          dispatch(getTenantsDataActionFailure(error));
        }
      }
  };
}

export const getTenantsDataActionBegin = () => ({
    type: FETCH_ADMINPERMISSIONS_BEGIN,
  });
  
  export const getTenantsDataActionSuccess = (TenantData) => ({
    type: FETCH_ADMINPERMISSIONSTENANT_SUCCESS,
    payload: {TenantData},
  });

  export const getTenantsDataActionFailure = (errorMessage) => ({
    type: FETCH_ADMINPERMISSIONS_FAILURE,
    payload: {errorMessage}
  });

export const getThemeDataAction=()=>{ 
  return async (dispatch) => {
    dispatch(getThemeDataActionBegin());
      try {
          const response = await sbaAxios({
              url: `${getThemes}`,
              method: 'get',
          })
        const ThemeData = response;
        dispatch(getThemeDataActionSuccess(ThemeData));
      } catch (error) {
        if (error.message === 'Network Error') {
          dispatch(getThemeDataActionSuccess({}));
        } else {
          dispatch(getThemeDataActionFailure(error));
        }
      }
  };
}
  
export const getThemeDataActionBegin = () => ({
    type: FETCH_ADMINTHEMES_BEGIN,
  });
  
export const getThemeDataActionSuccess = (ThemeData) => ({
  type: FETCH_ADMINTHEME_SUCCESS,
  payload: {ThemeData},
});

export const getThemeDataActionFailure = (errorMessage) => ({
  type: FETCH_ADMINTHEMES_FAILURE,
  payload: {errorMessage}
});

export const getReportDataAction=()=>{ 
  return async (dispatch) => {
    dispatch(getReportDataActionBegin());
      try {
          const response = await sbaAxios({
              url: `${getReports}`,
              method: 'get',
          })
        const ReportData = response;
        dispatch(getReportDataActionSuccess(ReportData));
      } catch (error) {
        if (error.message === 'Network Error') {
          dispatch(getReportDataActionSuccess({}));
        } else {
          dispatch(getReportDataActionFailure(error));
        }
      }
  };
}
  
export const getReportDataActionBegin = () => ({
    type: FETCH_ADMINTHEMES_BEGIN,
  });
  
export const getReportDataActionSuccess = (ReportData) => ({
  type: FETCH_ADMINREPORT_SUCCESS,
  payload: {ReportData},
});

export const getReportDataActionFailure = (errorMessage) => ({
  type: FETCH_ADMINTHEMES_FAILURE,
  payload: {errorMessage}
});

export const getThemeGridDataAction=(ThemeId, ReportId)=>{ 
  return async (dispatch) => {
    dispatch(getThemeGridDataActionBegin());
      try {
          const response = await sbaAxios({
              url: `${getThemeDetails}?ThemeId=${ThemeId}&ReportId=${ReportId}`,
              method: 'get',
          })
        const ThemeGridData = response;
        dispatch(getThemeGridDataActionSuccess(ThemeGridData));
      } catch (error) {
        if (error.message === 'Network Error') {
          dispatch(getThemeGridDataActionSuccess({}));
        } else {
          dispatch(getThemeGridDataActionFailure(error));
        }
      }
  };
}
  
export const getThemeGridDataActionBegin = () => ({
    type: FETCH_ADMINTHEMES_BEGIN,
  });
  
export const getThemeGridDataActionSuccess = (ThemeGridData) => ({
  type: FETCH_ADMINTHEMEDETAILS_SUCCESS,
  payload: {ThemeGridData},
});

export const getThemeGridDataActionFailure = (errorMessage) => ({
  type: FETCH_ADMINTHEMES_FAILURE,
  payload: {errorMessage}
});

export const getThemeListDataAction=(ThemeId)=>{ 
  return async (dispatch) => {
    dispatch(getThemeListDataActionBegin());
      try {
          const response = await sbaAxios({
              url: `${getThemeList}?ThemeId=${ThemeId}`,
              method: 'get',
          })
        const ThemeListData = response;
        dispatch(getThemeListDataActionSuccess(ThemeListData));
      } catch (error) {
        if (error.message === 'Network Error') {
          dispatch(getThemeListDataActionSuccess({}));
        } else {
          dispatch(getThemeListDataActionFailure(error));
        }
      }
  };
}
  
export const getThemeListDataActionBegin = () => ({
    type: FETCH_ADMINTHEMES_BEGIN,
  });
  
export const getThemeListDataActionSuccess = (ThemeListData) => ({
  type: FETCH_ADMINTHEMELIST_SUCCESS,
  payload: {ThemeListData},
});

export const getThemeListDataActionFailure = (errorMessage) => ({
  type: FETCH_ADMINTHEMES_FAILURE,
  payload: {errorMessage}
});

export const getReportPartListDataAction=()=>{ 
  return async (dispatch) => {
    dispatch(getReportPartDataActionBegin());
      try {
          const response = await sbaAxios({
              url: `${getReportPartList}`,
              method: 'get',
          })
        const ReportPartListData = response;
        dispatch(getReportPartDataActionSuccess(ReportPartListData));
      } catch (error) {
        if (error.message === 'Network Error') {
          dispatch(getReportPartDataActionSuccess({}));
        } else {
          dispatch(getReportPartDataActionFailure(error));
        }
      }
  };
}
  
export const getReportPartDataActionBegin = () => ({
    type: FETCH_ADMINTHEMES_BEGIN,
  });
  
export const getReportPartDataActionSuccess = (ReportPartListData) => ({
  type: FETCH_ADMINREPORTPART_SUCCESS,
  payload: {ReportPartListData},
});

export const getReportPartDataActionFailure = (errorMessage) => ({
  type: FETCH_ADMINTHEMES_FAILURE,
  payload: {errorMessage}
});

export const getReportPartListByIdDataAction=(ReportId)=>{ 
  return async (dispatch) => {
    dispatch(getReportPartListByIdDataActionBegin());
      try {
          const response = await sbaAxios({
              url: `${getReportpartListById}${ReportId}`,
              method: 'get',
          })
        const ReportPartListByIdData = response;
        dispatch(getReportPartListByIdDataActionSuccess(ReportPartListByIdData));
      } catch (error) {
        if (error.message === 'Network Error') {
          dispatch(getReportPartListByIdDataActionSuccess({}));
        } else {
          dispatch(getReportPartListByIdDataActionFailure(error));
        }
      }
  };
}
  
export const getReportPartListByIdDataActionBegin = () => ({
    type: FETCH_ADMINTHEMES_BEGIN,
  });
  
export const getReportPartListByIdDataActionSuccess = (ReportPartListByIdData) => ({
  type: FETCH_ADMINREPORTPARTLIST_SUCCESS,
  payload: {ReportPartListByIdData},
});

export const getReportPartListByIdDataActionFailure = (errorMessage) => ({
  type: FETCH_ADMINTHEMES_FAILURE,
  payload: {errorMessage}
});